import { forwardRef } from 'react';
import { StyledCard, type CardAntProps } from './StyledCard';

export const Card = forwardRef<HTMLDivElement, CardAntProps>((props, ref) => {
  return (
    <StyledCard
      ref={ref}
      onKeyDown={e => {
        if (e.key === 'Enter' || e.key === ' ') {
          const focusedTab = document.activeElement;
          if (focusedTab?.closest('[role="tab"]')) {
            (focusedTab as HTMLElement).click();
          }
        }
      }}
      {...props}
    />
  );
});

Card.displayName = 'Card';
